import { useMemo } from "react";

import { useLocation } from "react-router-dom";

const useHash = () => {
  const { hash } = useLocation();
  const h = useMemo(() => hash?.replace("#", "") || "", [hash]);
  return h;
};

export default useHash;
